module.exports = __webpack_public_path__ + "img/project13_4.png.27520bc3.webp";